import React from "react";
import { isAndroidHybridApp } from "../isAndroidWebView/isAndroidWebView.js";
export function hideOnAndroidWebView(Comp) {
    return function HideOnAndroidWebView(props) {
        const [show, setShow] = React.useState(true);
        React.useEffect(() => {
            setShow(!isAndroidHybridApp());
        }, []);
        if (!show) {
            return null;
        }
        return <Comp {...props}/>;
    };
}
